import React, { useEffect, useMemo, useRef, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
// import useTabStore from "../../localStore/useTabStore";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";
import usePermission from "../../customHook/usePermission";

const FoodsManagement = () => {
  const foodTab = 1;

  const arr = [
    { id: 1, name: "Available Order’s" },
    { id: 2, name: "Expired Order’s" },
  ];

  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [page, setPage] = useState(location?.state?.page || 1);
  const [totalCount, setTotalCount] = useState();
  const [pagination, setPagination] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pageRef = useRef(page);
  const preSearchPageRef = useRef(page);
  const [tab, setTab] = useState(location?.state?.tab || 1);

  const permission = usePermission();

  const tabRef = useRef(location?.state?.tab || 1);

  // const fetchData = async () => {
  //   let payload = {
  //     type: tab == 1 ? "available" : "expired",
  //     // page: page,
  //     search: searchText,
  //   };
  //   let url = `${URLS.FOOD_LIST}?page=${page}`;
  //   let res = await post(url, payload);
  //   if (res?.status == "success") {
  //     setData(res?.data);
  //     setTotalCount(res?.count || 0);
  //     setPagination({
  //       current_page: res?.current_page || 1,
  //       last_page: res?.total_pages || 1,
  //     });
  //   }
  // };

  const fetchData = async () => {
    let payload = {
      type: tab == 1 ? "available" : "expired",
      search: searchText,
    };

    let url = `${URLS.FOOD_LIST}?page=${page}`;
    let res = await post(url, payload);

    if (res?.status === "success") {
      const lastPage = res?.total_pages || 1;

      // ✅ FIX: clamp page to valid range
      if (page > lastPage) {
        setPage(lastPage);
        return; // stop current execution
      }

      setData(res?.data);
      setTotalCount(res?.count || 0);
      setPagination({
        current_page: res?.current_page || 1,
        last_page: lastPage,
      });
    }
  };

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    if (location?.state?.page) {
      // clear state after using it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, searchText, tab]);

  const handleSelect = (i) => {
    setTab(i.id);
    tabRef.current = i.id;
    setPage(1);
    // set("foodTab", i.id);
  };

  // console.log("tabValue", tabRef);

  const handleView = (i) => {
    navigate("/foods-view", {
      state: {
        id: i?.id,
        tab: tabRef.current,
        page: page,
      },
    });
  };
  console.log("data", tab);
  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return <span className="sno">{row.index + 1}</span>;
        },
      },
      {
        Header: "Food ID",
        accessor: "food_id",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Seller Name",
        accessor: "seller_name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Food Name",
        accessor: "food_name",
        width: "70%",
        Cell: ({ value }) => {
          return (
            <p
              className="mb-0"
              style={{
                width: 290,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Quantity",
        accessor: "available_quantity",
        width: "70%",
        Cell: ({ value }) => {
          return (
            <p className="mb-0" style={{ marginLeft: 10 }}>
              {value}
            </p>
          );
        },
      },
      {
        Header: "Price",
        accessor: "amount",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value}</p>;
        },
      },
      // {
      //   Header: "Order Type",
      //   accessor: "booking_type",
      //   width: "70%",
      //   Cell: ({ value }) => {
      //     return <p className="mb-0">{value}</p>;
      //   },
      // },
      {
        Header: "Date & Time",
        width: "70%",
        Cell: ({ row }) => {
          const isPreBooking = row?.original?.booking_type === "Pre Booking";

          const dateTime = isPreBooking
            ? row?.original?.created_at
            : row?.original?.created_at;

          return (
            <p className="mb-0 text-nowrap">
              {dateTime
                ? moment(dateTime).format("DD-MM-YYYY, h:mm A")
                : "--"}
            </p>
          );
        },
      }
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-FOODS_MANAGEMENT") && (
              <button
                className="action-btn d-flex ac-jc"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, action];
  }, [page]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(preSearchPageRef.current || 1);
  };

  return (
    <div>
      <PageHeader title="Foods Management " />
      <div className="d-flex gap-5 mb-5">
        {arr.map((i) => {
          return (
            <button
              onClick={() => handleSelect(i)}
              className={
                tab == i.id ? "header-action-btn" : "header-action-white-btn"
              }
              key={i.id}
            >
              {i.name}
            </button>
          );
        })}
      </div>

      <div className="header-row">
        <h2 className="total-count">Total: {totalCount || 0}</h2>

        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              const val = e.target.value;

              if (!searchText && val) {
                preSearchPageRef.current = page || 1;
                setPage(1);
              } else if (searchText && !val) {
                setPage(preSearchPageRef.current || 1);
              }

              setSearchText(val);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>

      <CommonTable
        columns={columns}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
    </div>
  );
};

export default FoodsManagement;
